import { Settings, SettingsContext } from '@distribusion/owl-frontend-ui'
import React, { ReactNode, useMemo } from 'react'

import currencyUtils from '@lib/currency'
import { getLocale as getDateLocale } from '@lib/date'
import { useSettings } from '@queries/settings'
import { useParams } from '@stores/params'

const UISettingsContextProvider = ({ children }: { children: ReactNode }) => {
  const [
    {
      userInterface: { date, time },
    },
  ] = useSettings()
  const [{ locale }] = useParams()

  const settings: Settings = useMemo(
    () => ({
      dateLocale: getDateLocale(locale),
      currency: {
        getSymbol: currency => currencyUtils.getSymbol(currency as Currency),
        create: (price, code, options) =>
          currencyUtils.create(
            price,
            code as Currency | undefined,
            options as {
              locale?: Locale
            },
          ),
      },
      time,
      date,
    }),
    [date, locale, time],
  )

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>
}

export default UISettingsContextProvider
